import { addVariant, fetchCart } from '../../js/lib/cart'; // eslint-disable-line

export default class GiftProduct {
  constructor(element, ctx) {
    this.element = element;
    this.ctx = ctx;

    this.trigger = this.element.querySelector('[data-add-gift]');
    this.isEnabled = !!this.trigger;

    if (this.isEnabled) {
      this.config = JSON.parse(this.trigger.dataset.giftConfig);
      this.visibility();

      this.ctx.on('cart:updated', (data) => {
        this.data = data;

        this.visibility();
      });

      this.addItem = this.addItem.bind(this);
      this.trigger.addEventListener('click', this.addItem);
    }
  }

  async addItem() {
    const { variantId } = this.config;
    const quantity = await this.getQuantity();

    await addVariant({
      variantId,
      quantity,
      callback: () => {
        this.trigger.hidden = true;
      },
    });
  }

  visibility() {
    if (!this.data) return;

    const { productId } = this.config;
    const ids = this.data.items.map((item) => item.productId);

    if (ids.includes(productId)) {
      this.trigger.hidden = true;
    } else {
      this.trigger.hidden = false;
    }
  }

  async getQuantity() {
    const { productId } = this.config;
    const cart = this.data ?? await GiftProduct.getCart();
    const validProducts = cart.items.filter((item) => (
      !item.excludeGiftBag
      && !item.gift_card
      && item.productId !== parseInt(productId, 10)
    ));

    const quantities = validProducts.map((item) => item.quantity);

    if (quantities.length) {
      const totalQuantity = quantities.reduce((value, total) => value + total);
      return totalQuantity;
    }

    return 0;
  }

  static getCart() {
    return fetchCart();
  }
}
